webpackJsonp([0,2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_router__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Rating__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_Rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_components_Rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ListBeers__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_ListBeers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_components_ListBeers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AddNew__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_AddNew___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_components_AddNew__);






__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router___default.a);

/* harmony default export */ __webpack_exports__["a"] = new __WEBPACK_IMPORTED_MODULE_1_vue_router___default.a({
  mode: 'history',
  linkActiveClass: 'is-active',
  routes: [{
    path: '/',
    name: 'Rating',
    component: __WEBPACK_IMPORTED_MODULE_2_components_Rating___default.a
  }, {
    path: '/list-beers',
    name: 'ListBeers',
    component: __WEBPACK_IMPORTED_MODULE_3_components_ListBeers___default.a
  }, {
    path: '/add-new',
    name: 'AddNew',
    component: __WEBPACK_IMPORTED_MODULE_4_components_AddNew___default.a
  }]
});

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(14)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(28),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue__);




/* harmony default export */ __webpack_exports__["default"] = {
  components: { Navbar: __WEBPACK_IMPORTED_MODULE_0__components_Navbar_vue___default.a },
  name: 'app'
};

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'rating',
  data: function data() {
    return {
      msg: 'Skapa ny öl provning'
    };
  }
};

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'rating'
};

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = {
  name: 'navbar'
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


var Vue = __webpack_require__(3);
var VueFire = __webpack_require__(32);
var Firebase = __webpack_require__(18);

Vue.use(VueFire);

var config = {
  apiKey: 'AIzaSyCFXAzszhasx4hrTsWIwg9enQlsJjIyXfY',
  authDomain: 'ol3-e6f7e.firebaseapp.com',
  databaseURL: 'https://ol3-e6f7e.firebaseio.com',
  storageBucket: 'ol3-e6f7e.appspot.com',
  messagingSenderId: '899708211125'
};
Firebase.initializeApp(config);

var db = Firebase.database();
var ratingsRef = db.ref('ratings');
var beersRef = db.ref('beers');

/* harmony default export */ __webpack_exports__["default"] = {
  name: 'rating',
  data: function data() {
    return {
      beerRating: {
        name: '',
        beer: '',
        rating: 0
      },
      newBeer: {
        name: ''
      },
      sliderValue: 0
    };
  },

  firebase: {
    ratings: ratingsRef,
    beers: beersRef.limitToLast(3)
  },
  computed: {
    validation: function validation() {
      return {
        name: !!this.beerRating.name.trim()
      };
    },
    total: function total() {
      return this.sliderValue / 4;
    },
    isValid: function isValid() {
      var name = this.beerRating.name;
      var beer = this.beerRating.beer;

      if (name.length > 2 && beer !== '') {
        return true;
      }

      return false;
    }
  },

  methods: {
    addRating: function addRating() {
      if (this.isValid) {
        this.beerRating.rating = this.total;

        ratingsRef.push(this.beerRating);

        this.sliderValue = 0;
        this.beerRating.beer = '';
      }
    }
  }
};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(29),
  /* scopeId */
  "data-v-7eff27e2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(27),
  /* scopeId */
  "data-v-73756cb6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(11)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(25),
  /* scopeId */
  "data-v-57b46340",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(12)

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(26),
  /* scopeId */
  "data-v-5d68d56d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar"
  }, [_c('nav', {
    staticClass: "nav has-shadow"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "nav-left"
  }, [_c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/",
      "exact": ""
    }
  }, [_vm._v("Sätt betyg")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/list-beers"
    }
  }, [_vm._v("Provade öl")]), _vm._v(" "), _c('router-link', {
    staticClass: "nav-item is-tab",
    attrs: {
      "to": "/add-new"
    }
  }, [_vm._v("Ny provning")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "container"
  }, [_c('form', {
    staticClass: "form-group",
    attrs: {
      "id": "form"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addRating($event)
      }
    }
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beerRating.name),
      expression: "beerRating.name"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Vem är du?"
    },
    domProps: {
      "value": _vm._s(_vm.beerRating.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.beerRating.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select is-medium"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.beerRating.beer),
      expression: "beerRating.beer"
    }],
    on: {
      "change": function($event) {
        _vm.beerRating.beer = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Välj en öl i listan ...")]), _vm._v(" "), _vm._l((_vm.beers), function(beer, index) {
    return _c('option', [_vm._v(_vm._s(beer.name))])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "range-wrapper"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sliderValue),
      expression: "sliderValue"
    }],
    staticClass: "range-input",
    attrs: {
      "type": "range",
      "min": "0",
      "max": "20",
      "step": "1"
    },
    domProps: {
      "value": _vm._s(_vm.sliderValue)
    },
    on: {
      "input": function($event) {
        _vm.sliderValue = $event.target.value
      }
    }
  }), _vm._v(" "), _c('output', {
    staticClass: "range-output",
    attrs: {
      "id": "rangeInfo"
    },
    domProps: {
      "textContent": _vm._s(_vm.total)
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    staticClass: "button is-primary is-medium",
    attrs: {
      "type": "submit",
      "disabled": !_vm.isValid,
      "value": "Sätt betyg på ölen!"
    }
  })])])])])
},staticRenderFns: []}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rating"
  }, [_c('h1', [_vm._v("Tidigare provade öl")])])
}]}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navbar'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rating"
  }, [_c('h1', [_vm._v(_vm._s(_vm.msg))])])
},staticRenderFns: []}

/***/ }),
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(4);





new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ })
],[33]);


// WEBPACK FOOTER //
// static/js/app.d47021e4e2246b33bf71.js